'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Text = require('../Text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItemText', function (theme) {
  return {
    root: {
      flex: '1 1 auto',
      padding: '0 ' + theme.typography.rhythmByUnit(1),
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    caption: {
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    flexDisplay: {
      display: 'flex'
    },
    inherit: {
      color: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit'
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.typography.rhythmByUnit(7)
      }
    },
    noWrap: theme.mixins.truncate({
      minWidth: 0
    }),
    primaryFlex: {
      flex: '1 1 auto'
    },
    selected: {
      fontWeight: theme.typography.fontWeightHeavy
    }
  };
});

var truncate = function truncate(text) {
  return text.length > 500 ? text.substr(0, 500) + '...' : text;
};

var ListItemText = (_temp = _class = function (_PureComponent) {
  _inherits(ListItemText, _PureComponent);

  function ListItemText() {
    _classCallCheck(this, ListItemText);

    return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
  }

  _createClass(ListItemText, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames2;

        var _props = this.props,
            caption = _props.caption,
            classNameProp = _props.className,
            inherit = _props.inherit,
            inset = _props.inset,
            noWrap = _props.noWrap,
            primary = _props.primary,
            primaryClassNameProp = _props.primaryClassName,
            secondary = _props.secondary,
            secondaryClassName = _props.secondaryClassName,
            selected = _props.selected,
            other = _objectWithoutProperties(_props, ['caption', 'className', 'inherit', 'inset', 'noWrap', 'primary', 'primaryClassName', 'secondary', 'secondaryClassName', 'selected']);

        var hasCaption = caption !== undefined;
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.inset, inset), _defineProperty(_classNames, classes.noWrap, noWrap), _classNames), classNameProp);
        var primaryClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.inherit, inherit), _defineProperty(_classNames2, classes.primaryFlex, hasCaption), _defineProperty(_classNames2, classes.selected, selected), _classNames2), primaryClassNameProp);

        return _react2['default'].createElement(
          'div',
          _extends({ className: className }, other),
          primary && (typeof primary !== 'string' ? primary : caption === undefined ? _react2['default'].createElement(
            _Text.Headline,
            _extends({
              className: primaryClassName
            }, { noWrap: noWrap }, {
              title: primary
            }),
            truncate(primary)
          ) : _react2['default'].createElement(
            'div',
            { className: classes.flexDisplay },
            _react2['default'].createElement(
              _Text.Headline,
              _extends({
                className: primaryClassName
              }, { noWrap: noWrap }, {
                title: primary
              }),
              truncate(primary)
            ),
            typeof caption === 'string' ? _react2['default'].createElement(
              _Text.Caption,
              { className: classes.caption, secondary: true },
              caption
            ) : caption
          )),
          secondary && (typeof secondary === 'string' ? _react2['default'].createElement(
            _Text.Body1,
            _extends({ className: secondaryClassName, secondary: true }, { noWrap: noWrap }),
            secondary
          ) : secondary)
        );
      }

      return render;
    }()
  }]);

  return ListItemText;
}(_react.PureComponent), _class.propTypes = {
  caption: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the primary element will inherit text styles.
   */
  inherit: _PropTypes2['default'].bool,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  inset: _PropTypes2['default'].bool,
  /**
   * If `false`, the text will wrap
   */
  noWrap: _PropTypes2['default'].bool,
  primary: _PropTypes2['default'].node,
  /**
   * The CSS class name of the primary element.
   */
  primaryClassName: _PropTypes2['default'].string,
  secondary: _PropTypes2['default'].node,
  /**
   * The CSS class name of the secondary element.
   */
  secondaryClassName: _PropTypes2['default'].string,
  /**
   * Use to apply selected styling.
   */
  selected: _PropTypes2['default'].bool
}, _class.defaultProps = {
  inherit: false,
  inset: false,
  noWrap: false,
  primary: false,
  secondary: false,
  selected: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = ListItemText;


ListItemText.displayName = 'ListItemText';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ListItemText.js
// module id = 740
// module chunks = 32